module.exports = __webpack_public_path__ + "image/VP_1.png";